import 'react';
import LoadingAndValidateComponent from './LoadingAndValidateComponent';

class ModalAndLoadingAndValidateComponent extends LoadingAndValidateComponent {
	constructor(props) {
		super(props);
		this.state = {
            ...this.state,
            isVisible: false,
		}
	}
	
	showModal = async () => {
		const isValid = await this.validate();
		if (isValid) {
			this.setState({ isVisible: true });
		}
	}

	hideModal = () => {
		this.setState({ isVisible: false });
	}
}

export default ModalAndLoadingAndValidateComponent;
